import { memo } from 'react';
import styled from 'styled-components';
import { Image } from '../Image';

const StyledNoDataContainer = styled.section`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #000000;
  padding: 5% 0%;
  background-color: #fff;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  img {
    width: 15%;
  }
  h2 {
    font-size: 18px;
    font-weight: bold;
    margin: 10px 0px 0px;
    padding: 0px;
    color: #000;
    @media (max-width: 600px) {
      font-weight: normal;
    }
  }
`;

const NoData = memo(({ message = 'No data found' }) => (
  <StyledNoDataContainer>
    <Image source={'/no-data.png'} alt={'No Data'} />
    <h2>{message}</h2>
  </StyledNoDataContainer>
));

export default NoData;
